const getPhrase = state => state.phrase || ''

export default {
  getPhrase
}